import {Box, Typography} from '@mui/material';

export interface ISegmentControlItem {
  id: string;
  label: string;
}

interface SegmentedControlProps {
  items: ISegmentControlItem[];
  value: string;
  onChange: (id: string) => void;
  className?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  items,
  value,
  onChange,
  className = '',
}) => {
  return (
    <Box className={`groups-dashboard-segment-control ${className}`}>
      {items.map(({id, label}) => {
        const active = value === id;

        return (
          <Box
            key={id}
            data-testid={`segment-control-item-${id}`}
            onClick={() => onChange(id)}
            className={`groups-dashboard-segment-control-item ${
              active ? 'active' : ''
            }`}>
            <Box className="groups-dashboard-segment-control-item-control-frame">
              <Typography
                className={`groups-dashboard-segment-control-item-label ${
                  active ? 'active' : ''
                }`}>
                {label}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
